import Icon from '../../components/Icon.vue'

Icon.register({"regular/eye":{"width":576,"height":512,"paths":[{"d":"M569.4 231.6C513 135.9 407.8 72 288 72 168.1 72 63 136 6.6 231.6A48-48 0 0 1 6.6 280.4C63 376.1 168.2 440 288 440 407.9 440 513 376 569.4 280.4A48-48 0 0 1 569.4 231.6zM288 392C185.4 392 95.9 337.3 48 256 92.2 181.1 171.7 128.7 264.2 121 274 131.1 280 144.8 280 160 280 190.9 254.9 216 224 216S168 190.9 168 160L168 160C157.8 179 152 200.8 152 224 152 299.1 212.9 360 288 360S424 299.1 424 224C424 193 413.6 164.4 396.1 141.5 451.7 164.6 498 205.1 528 256 480.1 337.3 390.6 392 288 392z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/eye.js
// module id = Kdqp
// module chunks = 0